<template>
  <div v-html="question.description" :style="!!maxHeight ? 'max-height: 300px; overflow-y: auto;' : ''"></div>
</template>

<script>
  export default {
    props: {
      value: Object, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
    },
    data() {
      return {
        trans: trans,
        answer: null,
      }
    },
    computed: {
      maxHeight() {
        return this.question && this.question.options && this.question.options.max_height ?
          this.question.options.max_height :
          null
      },
    },
  }
</script>